import { Button, Card, CardContent, Divider, Grid, Typography } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { IoArrowBack } from "react-icons/io5";
import { useLocation, useNavigate, useParams } from "react-router-dom";

const ViewRPLCourse = ({ color = "light" }) => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { id } = useParams();
  const { data: courseData } = useQuery({
    queryKey: ["rpl-course"],
    queryFn: () => getRPLCourse(),
  });
  const getRPLCourse = async () => {
    const res = await axios.get(`rpl-course/${id}`);
    return res?.data?.data;
  };

  const userRole = JSON.parse(localStorage.getItem("userDetail"))?.type;
  const InfoSection = ({ label, value }) => (
    <div className="mb-4">
      <Typography variant="subtitle2" className="text-app-text-secondary mb-1">
        {label}
      </Typography>
      <Typography variant="body1" className="font-medium">
        {value || "N/A"}
      </Typography>
    </div>
  );

  const CostSection = ({ label, value }) => (
    <div className="mb-4">
      <Typography variant="subtitle2" className="text-app-text-secondary mb-1">
        {label}
      </Typography>
      <Typography variant="body1" className="font-medium">
        {value?.toLocaleString() || "N/A"}
      </Typography>
    </div>
  );

  return (
    <div className="flex flex-wrap mt-4 dashBody">
      <div className="w-full mb-12 px-4">
        <div
          className={
            "relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded " +
            "bg-app-surface text-app-text"
          }
        >
          <div className="w-full flex items-center justify-between px-4 py-3">
            <div className="relative  flex justify-start gap-4 items-center">
              <IoArrowBack className="text-xl cursor-pointer" onClick={() => navigate(-1)} />
              <h3 className={"font-semibold text-xl text-app-text"}>RPL Course Details</h3>
            </div>
            {userRole === "SUPER_ADMIN" && (
              <Button
                variant="contained"
                onClick={() =>
                  navigate(`/admin/rpl-course/add/`, {
                    state: { item: courseData },
                  })
                }
              >
                Edit Course
              </Button>
            )}
          </div>

          <div className="block w-full overflow-x-auto mt-8">
            <div className="flex-auto lg:px-10 py-10 pt-0">
              <Grid container spacing={4}>
                {/* Course Information */}
                <Grid item xs={12} md={6}>
                  <Card className="h-full">
                    <CardContent>
                      <Typography variant="h6" className="mb-4 font-semibold">
                        Course Information
                      </Typography>
                      <Divider className="mb-4" />
                      <InfoSection label="Course Name" value={courseData?.courseName} />
                      <InfoSection label="College Name" value={courseData?.collegeName} />
                      <InfoSection label="RTO Code" value={courseData?.rtoCode} />
                    </CardContent>
                  </Card>
                </Grid>

                {/* Cost Information */}
                <Grid item xs={12} md={6}>
                  <Card className="h-full">
                    <CardContent>
                      <Typography variant="h6" className="mb-4 font-semibold">
                        Cost Information
                      </Typography>
                      <Divider className="mb-4" />
                      <CostSection label="Minimum Cost" value={courseData?.minCost} />
                      <CostSection label="Maximum Cost" value={courseData?.maxCost} />
                      <CostSection label="Selling Cost" value={courseData?.sellCost} />
                    </CardContent>
                  </Card>
                </Grid>

                {/* Requirements */}
                <Grid item xs={12}>
                  <Card>
                    <CardContent>
                      <Typography variant="h6" className="mb-4 font-semibold">
                        Course Requirements
                      </Typography>
                      <Divider className="mb-4" />
                      <div className="prose max-w-none">
                        <div
                          dangerouslySetInnerHTML={{
                            __html: courseData?.requirements || "No requirements specified",
                          }}
                        />
                      </div>
                    </CardContent>
                  </Card>
                </Grid>

                {/* Notes */}
                {courseData?.note && (
                  <Grid item xs={12}>
                    <Card>
                      <CardContent>
                        <Typography variant="h6" className="mb-4 font-semibold">
                          Additional Notes
                        </Typography>
                        <Divider className="mb-4" />
                        <Typography variant="body1">{courseData?.note}</Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                )}
              </Grid>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewRPLCourse;
